<div class="d-flex gap-1 cancel align-items-center show-error px-2">
  <img style="width: 20px" src="assets/images/tickets/danger-alert.svg" />
  <span>{{ message }}</span>
  <i style="cursor: pointer" (click)="dismiss()" class="fa fa-close"></i>
</div>
